<template>
  <div class="DetailQues">
    <div class="title">问卷</div>
<!--    <detail-title-bar :data="data"/>-->
    <div :class="off ? 'content' : 'off content'">
      <!--      <div class="message">{{item.question}}</div>-->
      <!--      题目选项-->
      <div v-for="item in questionList" :key="item.id">
        <div v-if="item.type === 1" class="radio">
          <div class="radio-title">{{ item.question }}（单选）</div>
          <van-radio-group v-model="item.optionid">
            <van-radio v-for="options in item.options" :key="options.id" checked-color="#00476C" :name="options.id">{{options.anwser}}</van-radio>
          </van-radio-group>
        </div>
        <div v-if="item.type === 2" class="radio">
          <div class="radio-title">{{item.question}}（可多选）</div>
          <van-checkbox-group v-model="item.optionid">
            <van-checkbox v-for="options in item.options" :key="options.id" checked-color="#00476C" :name="options.id">{{options.anwser}}</van-checkbox>
          </van-checkbox-group>
        </div>
        <div v-if="item.type === 3" class="radio">
          <div class="radio-title">{{item.question}}（开放）</div>
          <van-field
              v-model="item.optionid"
              rows="2"
              autosize
              type="textarea"
              placeholder="请输入留言"
          />
        </div>
        <div v-if="item.type === 4">
          <div class="message">{{item.question}}</div>
        </div>
      </div>
      <div v-show="!isQuestion" class="save-btn">
        <div class="save" @click="save">确认提交</div>
      </div>
      <div v-show="isQuestion" class="save-btn-2">
        <div class="save-2">已提交</div>
      </div>
    </div>
<!--    <div v-show="!off" class="btn" @click="off = 1">更多</div>-->
<!--    <div v-show="off" class="btn" @click="off = 0">收起</div>-->
  </div>
</template>

<script>
import DetailTitleBar from "@/views/meetings/detail/DetailTitleBar";

export default {
  name: "DetailQues",
  components: {DetailTitleBar},
  props: {
    questionList: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isQuestion: false,
      textarea: '',
      off: true,
      result: [
        'a'
      ],
      radio: '1'
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    get() {
      let id = this.$route.params.id
      let userId = localStorage.getItem('userId-school')
      this.$http.get(this.$api.question.getUser + `${id}/${userId}`).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.isQuestion = true
            for (let list of this.questionList) {
              for (let item of res.data) {
                if (list.id === item.questionid) {
                  if (list.type === 3) {
                    list.optionid = item.answer
                  } else {
                    list.optionid = JSON.parse(item.optionid)
                  }
                }
              }
            }
          }
        }
      })
    },
    save() {
      let arr = []
      let id = this.$route.params.id
      let user = localStorage.getItem('userId-school')
      for (let list of this.questionList) {
        let answer = null
        let opAnswer = []
        list.options.forEach(item => {
          if (list.type === 2) {
            if (!list.optionid) {
              return
            }
            for (let opId of list.optionid) {
              if (item.id === opId) {
                opAnswer.push(item.anwser)
              }
            }
            answer = opAnswer
          } else if (list.type === 3) {
            answer = list.optionid
            list.optionid = item.id
          } else if (list.type === 4) {
            answer = list.question
            list.optionid = item.id
          } else {
            if (item.id === list.optionid) {
              answer = item.anwser
            }
          }
        })
        arr.push({
          activityid: list.activityid,
          questionid: list.id,
          optionid: JSON.stringify(list.optionid),
          answer: JSON.stringify(answer),
        })
      }
      let isSave = true
      arr.forEach(a => {
        if (!a.answer) {
          this.$toast('所有选项必须填写才能提交')
          isSave = false
        }
      })
      if (isSave) {
        this.$http.post(this.$api.question.save + id + '/' + user, arr).then(res => {
          if (res.code === 0) {
            this.get()
            this.$toast('提交成功')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-cell {
    margin-top: 10px;
    border: 1px solid #eeeeee;
  }

  .van-radio, .van-checkbox {
    margin-top: 10px;
    font-size: 14px;
  }
}

.DetailQues {
  position: relative;
  border-bottom: 1px solid #ECECEC;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  margin-top: 20px;
  padding-bottom: 60px;

  .content {
    margin-bottom: 10px;
  }

  .off {
    height: 150px;
    overflow: hidden;
  }

  .btn {
    background: #ECECEC;
    width: 80px;
    height: 50px;
    font-size: 22px;
    color: #00476C;
    text-align: center;
    line-height: 50px;
    position: absolute;
    right: 25px;
    bottom: 10px;
  }

  .save-btn {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;

    .save {
      border-radius: 40px;
      width: 393px;
      height: 74px;
      background: #0091C5;
      color: #FFFFFF;
      font-size: 34px;
      line-height: 74px;
      font-weight: bold;
    }
  }

  .save-btn-2 {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    margin-bottom: 50px;

    .save-2 {
      border-radius: 40px;
      width: 393px;
      height: 74px;
      background: #ECECEC;
      color: #D2D2D2;
      font-size: 34px;
      line-height: 74px;
      font-weight: bold;
    }
  }

  .radio-title {
    font-size: 30px;
    color: #00476C;
    text-align: left;
    margin-top: 30px;
  }

  .message {
    color: #333333;
    font-size: 28px;
    text-align: left;
    margin-top: 30px;
  }

  .title {
    text-align: left;
    font-size: 34px;
    color: #00476C;
    font-weight: 600;
  }
}
</style>
